<template>
  <div class="review-modal">
    <div class="booking-requested">
      <!--      <a-->
      <!--          data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cc4"-->
      <!--          href="#"-->
      <!--          class="link-block-5 w-inline-block"-->
      <!--      >-->
      <!--        <img-->
      <!--            @click="cancel"-->
      <!--            src="@/assets/timeslot-images/cancel.svg"-->
      <!--            loading="lazy"-->
      <!--            alt=""-->
      <!--        />-->
      <!--      </a>-->
      <div class="div-block-86-active">
        <img
          :src="
            singleProfessional.customerDisplayPicture ||
              require('@/assets/timeslot-images/profileImg.svg')
          "
          loading="lazy"
          class="prof-image"
          alt=""
        />
      </div>
      <div class="div-block-52">
        <h1 class="modal-heading">Drop a review</h1>
      </div>
      <p class="paragraph-7">
        Review the previous bookings you have had with
        <!--        <strong>{{ profName }}</strong-->
        <strong>{{ singleProfessional.customerName }}</strong>
      </p>
      <div
        data-w-id="caac9a15-5baa-ef5a-3411-d43737a55cdc"
        class="button-15 w-button"
        @click="buttonAction"
      >
        Review bookings
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";

export default {
  name: "ReviewToBookingModal",
  props: {
    buttonAction: Function
  },
  computed: {
    ...mapState({
      singleProfessional: state => state.professional.singleProfessional,
      userInfo: state => state.auth.userInfo
    })
  },
  methods: {
    // goToBookings(){
    //   RouterUtils.changeRouteUrlTo("/customer-bookings")
    //   RouterUtils.changeRouteUrlTo("/professional-bookings")
    // }
  }
};
</script>

<style scoped>
.prof-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>
